import { amazonEcrPlugin } from './plugin';

export default amazonEcrPlugin;